import 'amfe-flexible';
import Vue from 'vue';
import { Field, Toast, Uploader } from 'vant';
import { getInitPageInfo, track, trackLaunch, initSentry } from '@/libs/tool';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/libs/skin';
import '@/assets/styles/common.css';
import '@/libs/max-rem-unit';
import './assets/css/share.css';
import './assets/css/black-skin.scss';

Vue.use(Field);
Vue.use(Uploader);
Vue.config.productionTip = false;
Vue.prototype.$toast = Toast;
Vue.prototype.$track = track;
Vue.prototype.$trackLaunch = trackLaunch;

console.log('build env ==>> ', process.env.NODE_ENV);

/* eslint-disable */
if (process.env.BUILD_ENV === 'mock') require('@/mock');

getInitPageInfo().then(async _ => {
    initSentry(router);
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
});
